import React, { Children, cloneElement } from 'react'
// libs
import styled from 'styled-components'

const ChildrenWrapper = styled.div`
  height: 100%;
`

const Wrapper = styled.div`
  padding: 5px 4px 5px 0;
`

const TreeNodeRenderer = (props) => {
  const {
    children,
    swapFrom,
    swapLength,
    swapDepth,
    scaffoldBlockPxWidth,
    lowerSiblingCounts,
    connectDropTarget,
    isOver,
    draggedNode,
    canDrop,
    treeIndex,
    treeId,
    listIndex,
    rowDirection,
    getPrevRow, // Delete from otherProps
    node, // Delete from otherProps
    path, // Delete from otherProps
    ...otherProps
  } = props

  // Construct the scaffold representing the structure of the tree
  const paddingLeft = scaffoldBlockPxWidth * (lowerSiblingCounts.length - 1)

  return (
    <Wrapper {...otherProps} ref={connectDropTarget} key={node.id} className='tree-node'>
      <ChildrenWrapper style={{ paddingLeft }}>
        {Children.map(children, (child) =>
          cloneElement(child, {
            isOver,
            canDrop,
            draggedNode,
            paddingLeft,
            formMarginLeft:
              scaffoldBlockPxWidth * (node.parent ? lowerSiblingCounts.length - 1 : lowerSiblingCounts.length)
          })
        )}
      </ChildrenWrapper>
    </Wrapper>
  )
}

TreeNodeRenderer.defaultProps = {
  swapFrom: null,
  swapDepth: null,
  swapLength: null,
  canDrop: false,
  draggedNode: null,
  rowDirection: 'ltr'
}

// TreeNodeRenderer.propTypes = {
//   treeIndex: number.isRequired,
//   swapFrom: number,
//   swapDepth: number,
//   swapLength: number,
//   scaffoldBlockPxWidth: number.isRequired,
//   lowerSiblingCounts: arrayOf(number).isRequired,
//   treeId: string.isRequired,
//   listIndex: number.isRequired,
//   rowDirection: string,
//   children: node.isRequired,
//
//   // Drop target
//   connectDropTarget: func.isRequired,
//   isOver: bool.isRequired,
//   canDrop: bool,
//   draggedNode: shape({}),
//
//   // used in dndManager
//   getPrevRow: func.isRequired,
//   node: shape({}).isRequired,
//   path: arrayOf(oneOfType([string, number])).isRequired
// }

export default TreeNodeRenderer
